import { configureStore } from "@reduxjs/toolkit";
import CartReducer from "./cart/CartSlice";
import AuthenticationReducer from "./authentication/AuthenticationSlice";
import categoryReducer from "./category/categorySlice";
import superCategoryReducer from "./superCategory/superCategorySlice";
import subCategoryReducer from "./subCategory/subCategorySlice";
import productReducer from "./product/ProductSlice";
import OrderReducer from "./order/OrderSlice";
import OrderShopReducer from "./order/OrderShopSlice";
import OrderSalonReducer from "./order/OrderSalonHomeSlice";
import TagReducer from "./tags/TagSlice";
import SaloonReducer from "./saloon/SaloonSlice";
import ShopCartSlice from "./cart/ShopCartSlice";
import SalonHomeCartReducer from "./cart/HomeSalon";
import productFlowReducer from "./subCategory/salonhomeslice";

export const store = configureStore({
  reducer: {
    Authentication: AuthenticationReducer,
    superCategory: superCategoryReducer,
    category: categoryReducer,
    Cart: CartReducer,
    ShopCart: ShopCartSlice,
    HomeSalonCart: SalonHomeCartReducer,
    subCategory: subCategoryReducer,
    products: productReducer,
    Order: OrderReducer,
    OrderShop: OrderShopReducer,
    OrderSalon: OrderSalonReducer,
    Tag: TagReducer,
    saloon: SaloonReducer,
    productFlowSlice: productFlowReducer,
  },
});
export default store;
